import { useEffect, useState } from 'react';
import FormGroup from './FormGroup';

const InputEmail = ({
    value,
    name,
    label,
    onChange,
    isRequired,
    requirementText,
    showError,
    externalErrorMessage,
    placeholder,
    inlineStyle = {},
}) => {
    const [inputValue, setInputValue] = useState(value);
    const [errorText, setErrorText] = useState('');
    const [isValid, setIsValid] = useState(true);

    const checkEmailValidity = email => {
        const emailRegex =
            /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        return emailRegex.test(email);
    };

    const handleInputChange = e => {
        const valid = checkEmailValidity(e.target.value);
        setInputValue(e.target.value);
        setIsValid(valid);
        onChange(e, valid);
    };

    useEffect(() => {
        const valid = checkEmailValidity(value);
        setIsValid(valid);
        let text = externalErrorMessage || '';
        if (isRequired && !value) {
            text = requirementText || 'This field is required';
        } else if (showError && !valid) {
            text = 'Invalid email format';
            const missingParts = [];
            if (!value.includes('@')) {
                missingParts.push('the @ symbol');
            } else {
                const afterAt = value.split('@')[1];
                if (!afterAt || afterAt.length === 0) {
                    missingParts.push('the email server (e.g. gmail.com)');
                } else if (!afterAt.includes('.')) {
                    missingParts.push('the domain part of the email (e.g. .com, .org, .net)');
                } else {
                    const domain = afterAt.split('.')[1];
                    if (!domain || domain.length === 0) {
                        missingParts.push('the domain part of the email (e.g. .com, .org, .net)');
                    }
                }
            }
            if (missingParts.length > 0) {
                text = `The email is missing ${missingParts[0]}`;
            }
        }
        setErrorText(text);
    }, [externalErrorMessage, isRequired, value, showError, isValid, requirementText]);

    const hasError = showError && (!isValid || externalErrorMessage);

    return (
        <FormGroup
            label={label}
            name={name}
            showError={showError}
            externalErrorMessage={errorText}
            required={isRequired}
        >
            <input
                value={inputValue}
                type="email"
                id={name}
                name={name}
                className={`form-control ${hasError ? ' error' : ''}`}
                placeholder={placeholder}
                style={inlineStyle}
                onChange={handleInputChange}
            />
        </FormGroup>
    );
};

export default InputEmail;
